'use strict';

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

require('../layout/slick');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _jquery2.default)('.reviews_slider').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  dots: true,
  customPaging: function customPaging(slider, i) {
    return '<span class="dot" data-index="' + i + '"></span>';
  },

  infinite: false,
  lazyLoad: true,
  responsive: [{
    breakpoint: 1150,
    settings: {
      arrows: false
    }
  }]
});

function popupSlider() {
  (0, _jquery2.default)('.popup-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    customPaging: function customPaging(slider, i) {
      return '<span class="dot" data-index="' + i + '"></span>';
    },

    infinite: false
  });
}

var btnOpenPopup = document.querySelectorAll('.open_review_popup');
var overlay = document.querySelectorAll('.page_reviews_stories_popup .overlay');
var closeBtns = document.querySelectorAll('.page_reviews_stories_popup .close');
var currentPopup = void 0;
if (btnOpenPopup.length) {
  setEvent();
}

function setEvent() {
  btnOpenPopup.forEach(function (btn) {
    return btn.addEventListener('click', openPopup);
  });
  closeBtns.forEach(function (btn) {
    return btn.addEventListener('click', closePopup);
  });
  overlay.forEach(function (btn) {
    return btn.addEventListener('click', closePopup);
  });
}

function openPopup(_ref) {
  var target = _ref.target;

  var index = target.dataset.btnIndex;
  var popup = document.querySelector('[data-popup-index="' + index + '"]');
  currentPopup = popup;
  popup.classList.add('active');
  popupSlider();
}

function closePopup() {
  (0, _jquery2.default)('.popup-slider').slick('unslick');
  currentPopup.classList.remove('active');
}